<template>
  <w-icon-wrapper
    :height='16'
    :width='24.866'
    icon-name='work-nav-expand-icon'
    view-box='0 0 24.866 16'
  >
    <g
      id="_21_Ausklappen_Icon"
      data-name="21_Ausklappen_Icon"
      transform="translate(-18 -99)"
    >
      <path
        id="menu_open_24dp_FILL0_wght400_GRAD0_opsz24"
        d="M120-704v-2.667h13.333V-704Zm0-6.667v-2.667h16.333v2.667Zm0-6.667V-720h13.333v2.667Z"
        transform="translate(-102 819)"
        fill="currentColor"
      />
      <path
        id="menu_open_24dp_FILL0_wght400_GRAD0_opsz24-2"
        data-name="menu_open_24dp_FILL0_wght400_GRAD0_opsz24"
        d="M137.333-705.333,144-712l-6.667-6.667-1.538,1.538-.328.328,4.8,4.8-4.8,4.8Z"
        transform="translate(-101.133 819)"
        fill="currentColor"
      />
    </g>
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavExpand' };
</script>